import Vue from 'vue';
export default () => {
  // 普通滚动
  Vue.directive('loadmore', {
    bind(el, binding, vNode) {
      let scrollPosition = 0;
      el.addEventListener('scroll', function () {
        if (vNode.context.isloadMore) return;
        let flagDirection = this.scrollTop - scrollPosition > 0;
        scrollPosition = this.scrollTop;
        const sign = 10;
        const scrollDistance =
          this.scrollHeight - (this.scrollTop + this.clientHeight) < sign;
        if (scrollDistance && flagDirection) {
          binding.value();
        }
      });
    },
  });
  // el-scroll向下滚动
  Vue.directive('scrollmore', {
    bind(el, binding, vNode) {
      let scrollPosition = 0;
      const wrap = el.querySelector('.el-scrollbar__wrap');
      wrap.addEventListener('scroll', function () {
        if (vNode.context.isloadMore) return;
        let flagDirection = this.scrollTop - scrollPosition > 0;
        scrollPosition = this.scrollTop;
        const sign = 10;
        const scrollDistance =
          this.scrollHeight - (this.scrollTop + this.clientHeight) < sign;
        if (scrollDistance && flagDirection) {
          binding.value();
        }
      });
    },
  });
  // el-scroll向上滚动
  Vue.directive('scrollup', {
    bind(el, binding, vNode) {
      let scrollPosition = 0;
      const wrap = el.querySelector('.el-scrollbar__wrap');
      wrap.addEventListener('scroll', function () {
        if (vNode.context.isloadMore) return;
        let flagDirection = this.scrollTop - scrollPosition < 0;
        scrollPosition = this.scrollTop;
        const sign = 10;
        const scrollDistance = this.scrollTop < sign;
        if (scrollDistance && flagDirection) {
          binding.value();
        }
      });
    },
  });
};
